import React from "react";
import { Routes as Switch, Route, Navigate } from "react-router-dom";
import { WebCheckIn } from "../pages/WebCheckinUser/CheckIns";
import { WebCheckOut } from "../pages/WebCheckinUser/CheckOut";

export const WebCheckinUserRoutes: React.FC = () => {
  return (
    <div style={{ display: "flex", flex: 1 }}>
      <Switch>
        <Route path="/checkin" element={<WebCheckIn />} />
        <Route path="/checkout" element={<WebCheckOut />} />
      </Switch>
    </div>
  );
};
